﻿import { PROJECT_STATUS } from "@/enums";

export const isProjectStatus = (status: string): boolean =>
  Object.values(PROJECT_STATUS.project).some(
    (projectStatus) => projectStatus.id === status
  );
